import { actionTypes } from '../../../controller';
import { SocketTypeEnums } from '../../../../lib/enums';

const {
	CONVERSATION_REPLY_TEXT_COMMAND_CREATE,
	CONVERSATION_REPLIES_COMMAND_GET,
	CONVERSATION_REPLY_FORM_TAGS_COMMAND_CREATE,
	CONVERSATION_REPLY_FORM_REPLY_COMMAND_CREATE,
	CONVERSATION_REPLY_TEXT_COMMAND_TYPING,
	CONVERSATION_REPLY_QA_OPTIONS_COMMAND_SELECT,
	CONVERSATION_REPLY_SMART_REPLY_COMMAND_RESET,
	CONVERSATION_REPLY_CONTACT_CS_COMMAND_CREATE,
	CONVERSATION_REPLY_QA_FORM_REPLY_COMMAND_CREATE,
	CONVERSATION_REPLY_QA_CHARGE_FORM_REPLY_COMMAND_CREATE,
} = SocketTypeEnums;
const {
	START_FETCH_CONVERSATION_REPLIES,
	START_FETCH_NEXT_CONVERSATION_REPLIES,
	START_CREATE_TEXT_CONVERSATION_REPLY,
	START_SELECT_CONVERSATION_TAG,
	START_CREATE_CONVERSATION_FORM_REPLY,
	START_SEND_TYPEING_CONVERSATION_REPLY,
	START_SELECT_CONVERSATION_QA_OPTION,
	START_RESET_CONVERSATION_SMART_REPLY,
	START_CONTACT_CS_CONVERSATION,
	START_CREATE_CONVERSATION_QA_FORM_REPLY,
	START_CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY,
} = actionTypes;

export function getConversationRepliesEmitter(socket) {
	return function (store, action) {
		const { type, pointer, limit, order, sort } = action;

		if (
			type === START_FETCH_CONVERSATION_REPLIES ||
			type === START_FETCH_NEXT_CONVERSATION_REPLIES
		) {
			socket.emit(CONVERSATION_REPLIES_COMMAND_GET, {
				messageId: type,
				pointer,
				limit,
				order,
				sort,
			});
		}
	};
}

export function sendTextConversationReplyEmitter(socket) {
	return function (store, action) {
		const { type, message, quoteReplyId } = action;

		if (type === START_CREATE_TEXT_CONVERSATION_REPLY) {
			socket.emit(CONVERSATION_REPLY_TEXT_COMMAND_CREATE, {
				messageId: CONVERSATION_REPLY_TEXT_COMMAND_CREATE,
				message,
				quoteReplyId,
			});
		}
	};
}

export function createConversationTagEmitter(socket) {
	return function (store, action) {
		const { type, data = {} } = action;
		const {
			conversationTagId,
			captchaKey,
			captchaSecret,
		} = data;

		if (type === START_SELECT_CONVERSATION_TAG) {
			socket.emit(CONVERSATION_REPLY_FORM_TAGS_COMMAND_CREATE, {
				messageId: CONVERSATION_REPLY_FORM_TAGS_COMMAND_CREATE,
				conversationTagId,
				captchaKey,
				captchaSecret,
			});
		}
	};
}

export function createConversationFormReplyEmitter(socket) {
	return function (store, action) {
		const { type, conversationReplyId, formReplies } = action;

		if (type === START_CREATE_CONVERSATION_FORM_REPLY) {
			socket.emit(CONVERSATION_REPLY_FORM_REPLY_COMMAND_CREATE, {
				messageId: CONVERSATION_REPLY_FORM_REPLY_COMMAND_CREATE,
				conversationReplyId,
				formReplies,
			});
		}
	};
}

export function sendTypingConversationReplyEmitter(socket) {
	return function (store, action) {
		const { type, message } = action;

		if (type === START_SEND_TYPEING_CONVERSATION_REPLY) {
			socket.emit(CONVERSATION_REPLY_TEXT_COMMAND_TYPING, {
				messageId: CONVERSATION_REPLY_TEXT_COMMAND_TYPING,
				message,
			});
		}
	};
}

export function selectConversationOptionEmitter(socket) {
	return function (store, action) {
		const { type, conversationReplyId, qaNodeId } = action;

		if (type === START_SELECT_CONVERSATION_QA_OPTION) {
			socket.emit(CONVERSATION_REPLY_QA_OPTIONS_COMMAND_SELECT, {
				messageId: CONVERSATION_REPLY_QA_OPTIONS_COMMAND_SELECT,
				conversationReplyId,
				qaNodeId,
			});
		}
	};
}

export function resetConversationSmartReplyEmitter(socket) {
	return function (store, action) {
		const { type, conversationReplyId } = action;

		if (type === START_RESET_CONVERSATION_SMART_REPLY) {
			socket.emit(CONVERSATION_REPLY_SMART_REPLY_COMMAND_RESET, {
				messageId: CONVERSATION_REPLY_SMART_REPLY_COMMAND_RESET,
				conversationReplyId,
			});
		}
	};
}

export function contactCSConversationEmitter(socket) {
	return function (store, action) {
		const { type, data = {} } = action;
		const {
			captchaKey,
			captchaSecret,
		} = data;

		if (type === START_CONTACT_CS_CONVERSATION) {
			socket.emit(CONVERSATION_REPLY_CONTACT_CS_COMMAND_CREATE, {
				messageId: CONVERSATION_REPLY_CONTACT_CS_COMMAND_CREATE,
				captchaKey,
				captchaSecret,
			});
		}
	};
}

export function createConversationQAformEmitter(socket) {
	return function (store, action) {
		const { type, data = {} } = action;
		const {
			captchaKey,
			captchaSecret,
			conversationReplyId,
			formReplies,
		} = data;

		if (type === START_CREATE_CONVERSATION_QA_FORM_REPLY) {
			socket.emit(CONVERSATION_REPLY_QA_FORM_REPLY_COMMAND_CREATE, {
				messageId: CONVERSATION_REPLY_QA_FORM_REPLY_COMMAND_CREATE,
				captchaKey,
				captchaSecret,
				conversationReplyId,
				formReplies,
			});
		}
	};
}

export function createConversationQAChargeformEmitter(socket) {
	return function (store, action) {
		const { type, conversationReplyId, chargeFormReply } = action;

		if (type === START_CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY) {
			socket.emit(CONVERSATION_REPLY_QA_CHARGE_FORM_REPLY_COMMAND_CREATE, {
				messageId: CONVERSATION_REPLY_QA_CHARGE_FORM_REPLY_COMMAND_CREATE,
				conversationReplyId,
				chargeFormReply,
			});
		}
	};
}
